module.exports = __webpack_public_path__ + "img/image-hero-4-banner.de68a96e.png";